import type {PropsWithChildren} from 'react'
import {SubscriptionContext} from './SubscriptionContext'
import {api} from '../../trpc/api'
import {noSubscriptionTier} from '@package/shared'

export const SubscriptionProvider = ({children}: PropsWithChildren) => {
  const {data: activeSubscriptionTier = noSubscriptionTier, isFetching: loading} =
    api.subscriptions.getActiveTier.useQuery()

  return (
    <SubscriptionContext.Provider
      value={{
        activeSubscriptionTier,
        loading,
      }}
    >
      {children}
    </SubscriptionContext.Provider>
  )
}
